import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import store from '@/store/store'
import Ripple from 'vuetify/lib/directives/ripple';

Vue.use(Vuetify, {
  rtl: true,
  directives: {
    Ripple,
  },
})

export default new Vuetify({
  iconfont: 'md',
  theme: {
    themes:{
      light:{
    primary: '#ac26e0',
    secondary: '#b0bec5',
    tertiary: '#495057',
    background: '#ffffff',
    accent: '#82B1FF',
    error: '#f55a4e',
    info: '#00d3ee',
    success: '#5cb860',
    warning: '#ffa21a'
      }
  }
}
});